import "../../style/globals/PageHeaderTitle.css";
import WrapperStyle from "../../utils/WrapperStyle";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";

const NotificationsTitle = () => {
    return (
        <>
            <div className="page-header-title" style={WrapperStyle()}>
                <div className="page-header-title-wrapper">
                    <div className="page-header-title-headline">
                        <NotificationsOutlinedIcon />
                        <h1>Bildirimler</h1>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NotificationsTitle;
